import { createInitialGuard } from './guards/initial.guard'
import { createPermissionGuard } from './guards/permission.guard'
import { createDatadogGuard } from './guards/datadog.guard'
import { createSysDateGuard } from './guards/sysDate.guard'

/* router settring
  router 이동전 체크 or 처리해야될것들을 setup
*/
export function setupRouterGuard(router) {
  createInitialGuard(router)
  createPermissionGuard(router)
  createDatadogGuard(router)
  createSysDateGuard(router)
}
